import { RootState } from '../../store';

export const mainDashboardSelector = (store: RootState) => store.mainDashboard;

export const userSelector = (store: RootState) => store.user.data;

export const machineGroupLoadingSelector = (store: RootState): boolean =>
  store.user.machineGroups.isLoading;

export const realtimeMachineStatusCounterSelector = (store: RootState) =>
  mainDashboardSelector(store).realtime;

export const getRealtimeMachineStatusData = (machineId: number | null) =>
  function (store: any) {
    if (!machineId) {
      return null;
    }
    const realtimeStore = realtimeMachineStatusCounterSelector(store);
    if (
      realtimeStore &&
      realtimeStore.data?.machines &&
      realtimeStore.data.machines.length > 0
    ) {
      return realtimeStore?.data.machines.find(
        (d: any) => d.machineId === machineId
      );
    }
    return null;
  };

export type UserData = {
  cognitoUsername: string;
  companies: any[];
  companyId: number;
  companyIds: number[];
  email: string;
  id: number;
  role: string;
  timezone: string;
  name: string;
};
